import { generateContext } from '@/context/utils';
import reducer from '@/product-registration/context/reducer';
import initialState from '@/product-registration/context/state';
import actions from '@/product-registration/context/actions';

const {
  ProductRegistrationProvider,
  useProductRegistrationContext,
} = generateContext(
  'ProductRegistrationProvider',
  'useProductRegistrationContext',
  initialState,
  reducer,
  actions,
);

export { ProductRegistrationProvider, useProductRegistrationContext };
